import { LoaderFunctionArgs, MetaFunction } from "react-router";
import { useLoaderData, useLocation } from "react-router";
import { useTranslation } from "react-i18next";

import { calculators, categories } from "~/catalog";
import H1 from "~/components/H1";
import ToolPlate from "~/components/ToolPlate";
import { makeTitle } from "~/helpers/pageTitle";
import { getLocale } from "~/i18n";
import { getTranslator } from "~/i18next.server";


export const meta: MetaFunction<typeof loader> = ({ data }) => [
  { title: makeTitle(data?.title) }
  // { name: "description", content: data?.description }
];

export const handle = {
  localisedLinks: ["en", "ru", "de", "fr", "es", "it", "pt"],
  breadcrumb: "catalog" // TODO
};

export const loader = async ({ request, params }: LoaderFunctionArgs) => {
  const t = await getTranslator(request);

  // This will ensure that invalid locales do not render page
  if (getLocale(request.url) === null) {
    throw new Response(null, { status: 404 });
  }

  let categoryExists = false;
  for (const category of categories) {
    if (category.id === params.category) {
      categoryExists = true;
      break;
    }
  }

  if (!categoryExists) {
    throw new Response(null, { status: 404 });
  }

  return {
    title: t("catalog.categories." + params.category),
    categoryId: params.category
  };
};


export default function RuIndex() {
  const { title, categoryId } = useLoaderData<typeof loader>();

  const { t } = useTranslation("translations");

  const locale = getLocale(useLocation().pathname) ?? "";

  return (
    <>
      <H1 className="mb-10">{title}</H1>

      <div
        className="pt-6 grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      >
        {calculators.map((calculator) =>
          calculator.category === categoryId
          && (calculator.locales === undefined || calculator.locales.includes(locale))
          && (calculator.excludedLocales === undefined || !calculator.excludedLocales.includes(locale))
            ? (
              <ToolPlate
                key={calculator.id}
                title={t(`calculators.${categoryId}.${calculator.id}.title`)}
                description={t(`calculators.${categoryId}.${calculator.id}.description`)}
                link={`/${locale}/${calculator.slug}`}
              />
            ) : null)
        }
      </div>
    </>
  );
}
